import type {
  AccessCodePolicy,
  EmailRegistrationPolicy,
  EmailWhitelistPolicy,
  ReferrerProtectionPolicy,
  SecurityPolicy,
  SingleSignOnPolicy,
  TokenProtectionPolicy,
} from '../generated/graphql-manager';
import type { WebcastContent } from '../generated/graphql-viewer';

// --- Manager ---

export const findAccessCodePolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is AccessCodePolicy => policy.__typename === 'AccessCodePolicy');

export const findSingleSignOnPolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is SingleSignOnPolicy => policy.__typename === 'SingleSignOnPolicy');

export const findReferrerProtectionPolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is ReferrerProtectionPolicy => policy.__typename === 'ReferrerProtectionPolicy');

export const findEmailRegistrationPolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is EmailRegistrationPolicy => policy.__typename === 'EmailRegistrationPolicy');

export const findEmailWhitelistPolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is EmailWhitelistPolicy => policy.__typename === 'EmailWhitelistPolicy');

export const findTokenProtectionPolicy = (policies: Partial<SecurityPolicy>[] = []) =>
  policies.find((policy): policy is TokenProtectionPolicy => policy.__typename === 'TokenProtectionPolicy');

// --- Viewer ---

export const findEventTitle = (
  contents?: WebcastContent[],
  selectedLanguageCode?: string,
  primaryLanguageCode?: string
) =>
  contents?.find((content) => content.language === selectedLanguageCode)?.title ||
  contents?.find((content) => content.language === primaryLanguageCode)?.title ||
  contents?.[0]?.title ||
  '';
